import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import { useState } from "react";
import { useAdmin } from "../../../context/admin";
import AdminService from "../../../services/admin.service";
import GeneralInput from "../../common/GeneralInput";
import Dropdown from "../../common/Dropdown";
import FileInput from "../../common/FileInput";
import jsonToFormData from "../../../utils/jsonToFormData";
import { useGlobal } from "../../../context/global";
import styled from "styled-components";

// pago múltiple de traspaso: una fila editable (tour/entradas) por pasajero seleccionado,
// método de pago/remarks/foto compartidos para todo el lote (un solo comprobante cubre a varios)
export default function CreateMultiPaymentReservation() {
    const { setMessage, setIsLoading } = useGlobal()
    const { createMultiPaymentReservations, setCreateMultiPaymentReservations, setCurrentDay } = useAdmin()
    const reservations = createMultiPaymentReservations || []

    const [rows, setRows] = useState(() => reservations.map(r => {
        const paidTour = r.payments?.reduce((acc, p) => acc + (p.amount || 0), 0) || 0
        const paidTickets = r.payments?.reduce((acc, p) => acc + (p.amount_tickets || 0), 0) || 0
        return {
            reservation_id: r.id,
            passenger_name: r.passenger?.name || '',
            amount: Math.max((r.traspass_price || 0) - paidTour, 0),
            amount_tickets: Math.max((r.tickets || 0) - paidTickets, 0)
        }
    }))
    const [remarks, setRemarks] = useState('')
    const [paymentMethod, setPaymentMethod] = useState('')
    const [pic, setPic] = useState<File>()

    const total = rows.reduce((acc, r) => acc + Number(r.amount || 0) + Number(r.amount_tickets || 0), 0)

    function updateRow(reservation_id: string, field: 'amount' | 'amount_tickets', value: string) {
        setRows(prev => prev.map(r => r.reservation_id === reservation_id ? { ...r, [field]: value === '' ? 0 : Number(value) } : r))
    }

    function close() {
        setCreateMultiPaymentReservations(undefined)
    }

    async function registerPayments(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            const toSubmit = rows.filter(r => Number(r.amount) > 0 || Number(r.amount_tickets) > 0)
            for (const row of toSubmit) {
                const formData = jsonToFormData({
                    reservation_id: row.reservation_id,
                    amount: Number(row.amount) || 0,
                    amount_tickets: Number(row.amount_tickets) || 0,
                    remarks,
                    payment_method: paymentMethod,
                    ...(pic ? { pic } : {})
                })
                await AdminService.registerReservationPayment(formData)
            }
            setMessage({ type: 'success', content: 'Pagos registrados correctamente' })
            setTimeout(() => setMessage(undefined), 2500)
            setCreateMultiPaymentReservations(undefined)
            setCurrentDay((prevDay: Date) => new Date(prevDay))
        } catch (error) {
            console.log(error)
            setMessage({ type: 'error', content: 'Hubo un error registrando los pagos' })
            setTimeout(() => setMessage(undefined), 2500)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal onSubmit={registerPayments}>
            <h1>Pago múltiple de traspaso</h1>
            <h2>{reservations.length} pasajero(s) seleccionado(s)</h2>
            <Rows>
                {rows.map(row => (
                    <div className="row" key={row.reservation_id}>
                        <span className="name">{row.passenger_name}</span>
                        <GeneralInput
                            label="Pagado de tour"
                            type="number"
                            value={row.amount}
                            onChange={e => updateRow(row.reservation_id, 'amount', e.target.value)}
                        />
                        <GeneralInput
                            label="Pagado de entradas"
                            type="number"
                            value={row.amount_tickets}
                            onChange={e => updateRow(row.reservation_id, 'amount_tickets', e.target.value)}
                        />
                    </div>
                ))}
            </Rows>
            <div className="total">Total a registrar: ${total.toLocaleString('es-CL')}</div>
            <GeneralInput
                label="Remarks"
                value={remarks}
                onChange={e => setRemarks(e.target.value)}
                style={{ margin: '20px 0' }}
            />
            <div className="payment">
                <h2>Payment method</h2>
                <h3>{paymentMethod}</h3>
                <Dropdown
                    title="Payment method"
                    options={['transfer', 'cash']}
                    onSelect={(newValue: string) => setPaymentMethod(newValue)}
                />
            </div>
            <FileInput
                style={{ margin: '10px 0' }}
                value={pic}
                deleteFile={() => setPic(undefined)}
                accept=".png, .jpg, .jpeg, .heic"
                onChange={(newFile: File) => setPic(newFile)}
            />
            <div className="actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button style={{ backgroundColor: 'green', color: 'white', border: 'none' }}>Registrar pagos</button>
                <button type="button" style={{ backgroundColor: 'gray', color: 'white', border: 'none' }} onClick={close}>Cancel</button>
            </div>
            <div className="close" onClick={close}>
                <AiOutlineCloseCircle />
            </div>
        </Modal>
    )
}

const Rows = styled.div`
width: 100%;
max-height: 300px;
overflow-y: auto;
margin: 15px 0;
.row {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    margin-bottom: 10px;
    .name {
        flex: 1;
        font-size: 14px;
        font-weight: 600;
    }
}
`
